import * as React from 'react'

export interface ChildrenProps {
  secondsRemaining: number
}

export interface Props {
  children: React.FunctionComponent<{ secondsRemaining: number }>
  onComplete: () => void
  started: boolean
  seconds: number
}

export const Timer: React.FC<Props> = ({ children, onComplete, seconds, started }) => {
  const [secondsRemaining, setSecondsRemaining] = React.useState(seconds)

  React.useEffect(() => {
    const timer = setInterval(() => {
      if (secondsRemaining <= 0) {
        clearInterval(timer)
        onComplete()
      } else if (started) {
        setSecondsRemaining(secondsRemaining - 1)
      }
    }, 1000)
    return () => {
      clearInterval(timer)
    }
  }, [onComplete, secondsRemaining, started])

  return children({ secondsRemaining })
}
